import { useEffect } from "react"
import { useToJpeg } from "@hugocxl/react-to-image"
import ChartLereyJennings from "../../../Releases/components/ChartLereyJennings/chart"
import { useChartLevereyJenning } from "../../../Releases/components/ChartLereyJennings/useChartLevereyJenning"
import TableAnalysis from "../../../Releases/components/TableAnalysis/table"
import { useTableAnalysis } from "../../../Releases/components/TableAnalysis/useTableAnalysis"

const ComponenntToImage = (props) => {
  const { children, onSuccess } = props
  const [state, convert, ref] = useToJpeg()

  useEffect(() => {
    if (!ref) return

    if (state?.data) {
      onSuccess(state.data)
      return
    }

    if (!state?.data && !state?.isLoading && !state?.error) {
      const timer = setTimeout(() => {
        convert()
      }, 15)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [ref, state])

  if (!children) return null

  return (
    <div style={{ position: "absolute", top: "-2000px", width: "100%" }}>
      <div style={{ position: "relative", width: "980px" }}>
        <div ref={ref}>
          <div style={{ background: "#fff" }}>{children}</div>
        </div>
      </div>
    </div>
  )
}

const ChartsToImages = (props) => {
  const { runs, onSuccess } = props
  const { chartData, runsWestardStatus } = useChartLevereyJenning({ aRuns: runs })

  if (!runs?.length) return null

  return (
    <ComponenntToImage onSuccess={onSuccess}>
      <ChartLereyJennings
        runs={runs}
        chartData={chartData}
        runsWestardStatus={runsWestardStatus}
      />
    </ComponenntToImage>
  )
}

const TablesToImages = (props) => {
  const { runs, onSuccess } = props
  const { aTableData } = useTableAnalysis({ aRuns: runs })
  if (!runs?.length) return null

  return (
    <ComponenntToImage runs={runs} onSuccess={onSuccess}>
      <TableAnalysis aTableData={aTableData} />
    </ComponenntToImage>
  )
}

const ProcessChartAndTableToImage = (props) => {
  const { analyte, processedReport, setProcessedReport } = props

  useEffect(() => {
    if (!analyte) return

    const allReports = [...(processedReport || [])] || []
    const item = allReports?.find((item) => item?.eqpanlt_nid === analyte?.eqpanlt_nid)
    if (item) return
    if (!analyte?.runs?.length) {
      allReports.push({
        ...analyte,
        componentsBase64: [],
        completedProcessComponents: true,
      })
      setProcessedReport(allReports)
    }
  }, [analyte, processedReport])

  const chartsLenght = Math.ceil(analyte?.runs?.length / 10)

  const fnHandleConvertToImage = (cImageBase64, index) => {
    if (!cImageBase64) return

    const allReports = [...(processedReport || [])] || []
    const item = allReports?.find((item) => item?.eqpanlt_nid === analyte?.eqpanlt_nid)

    if (item) {
      if (item?.componentsBase64?.filter((i) => i)?.length >= chartsLenght) {
        item.completedProcessComponents = true // all images has been generated
        setProcessedReport(allReports)
        return
      }

      item.componentsBase64[index] = cImageBase64
      setProcessedReport(allReports)
    } else {
      const newAnalyte = { ...analyte, componentsBase64: [] }
      newAnalyte.componentsBase64[index] = cImageBase64
      allReports.push({ ...newAnalyte })
      setProcessedReport(allReports)
    }
  }

  if (!analyte) return null

  const processedReportItem = processedReport?.find(
    (item) => item?.eqpanlt_nid === analyte?.eqpanlt_nid,
  )

  if (processedReportItem?.completedProcessComponents === true) return null

  if (!analyte?.runs?.length) return null

  const aGroupedRuns = analyte?.runs?.reduce((acc, run, index) => {
    const iGroup = Math.floor(index / 10)
    acc[iGroup] = acc[iGroup] || []
    acc[iGroup].push(run)
    return acc
  }, [])

  if (!aGroupedRuns?.length) return null

  return (
    <>
      {aGroupedRuns?.map((runs, index) => {
        if (analyte?.eqpanlt_anlt?.anlt_type !== "Quantitativo") {
          return (
            <TablesToImages
              key={`table-to-image-runs-${analyte?.eqpanlt_anlt?.anlt_nid}-${index}`}
              runs={runs}
              onSuccess={(cImageBase64) => fnHandleConvertToImage(cImageBase64, index)}
            />
          )
        }
        return (
          <ChartsToImages
            key={`chart-to-image-runs-${analyte?.eqpanlt_anlt?.anlt_nid}-${index}`}
            runs={runs}
            onSuccess={(cImageBase64) => fnHandleConvertToImage(cImageBase64, index)}
          />
        )
      })}
    </>
  )
}

export default ProcessChartAndTableToImage
